import axios from 'axios'
import Utils from '../services/Utils'

axios.defaults.timeout = 600000
axios.defaults.urls = JSON.parse(process.env.VUE_APP_URL)
axios.defaults.ptApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].base
Utils.updateAuthorization()


export default {
    getStrings(callback) {
        if (window.appCache && window.appCache.strings) {
            return Utils.processResponse({
                request: {
                    response: JSON.stringify({
                        success: true,
                        data: window.appCache.strings
                    })
                }
            }, callback)
        }
        axios.get(axios.defaults.ptApiUrl + 'translations?lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: axios.defaults.authorization,
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getEnums(callback) {
        if (window.appCache && window.appCache.enums) {
            Utils.refreshEnums(window.appCache.enums)
            return callback()
        }
        axios.get(axios.defaults.ptApiUrl + 'enums?pt_id=' + window.ptId + '&website=1', {
            headers: {
                'Content-Type': 'application/json',
                Authorization: axios.defaults.authorization,
            },
        }).then((response) => {
            let enums = {}
            if (response.data && response.data.data) {
                enums = response.data.data
            }
            Utils.refreshEnums(enums)
            callback()
        }).catch((response) => {
            Utils.refreshEnums({})
            callback()
        })
    },
    getContents(data, callback) {
        const supplementType = 100
        let filter = '&query=[{"f":"type","q":2,"v":' + supplementType + '}]'
        if (data && (data.type || data.type === 0)) {
            filter += '&search={"type":[' + data.type + ']' + (data.sub_type || data.sub_type === 0 ? (',"sub_type":[' + data.sub_type + ']') : '') + '}'
        }
        axios.get(axios.defaults.ptApiUrl + 'content?db_id=' + window.ptId + filter + '&image=1&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': axios.defaults.authorization
            }
        }).then((response) => {
            Utils.processResponse(response, callback);
        }).catch((response) => {
            Utils.processResponse(response, callback);
        });
    },
}
